import { render } from "./EmptyLayout.vue?vue&type=template&id=c3f6c9e2&ts=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts"

import "./EmptyLayout.vue?vue&type=style&index=0&id=c3f6c9e2&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__